module.exports = __webpack_public_path__ + "static/media/PLAM.be18e9a4.svg";